<template>
	<tr :class="{'striped-row': ind % 2 == 0}">
		<td><button v-on:click="expand" class="btn btn-sm btn-primary" data-bs-toggle="collapse" :data-bs-target="'.user_jobs_' + user.user_id" aria-expanded="false"><i v-if="expanded" :class="'fa-solid fa-minus'"></i><i v-else :class="'fa-solid fa-plus'"></i></button></td>
        <td>{{user.name}}</td>
        <td>{{user.email}}</td>
        <td>{{user.sp_hours}}</td>
        <td>{{user.no_show_hours}}</td>
        <td>{{user.learner_tech_hours}}</td>
        <td>{{user.late_canc_hours}}</td>
        <td>{{user.early_canc_hours}}</td>
        <td>{{user.scorecard_hours}}</td>
        <td>{{user.trainer_hours}}</td>
        <td>{{user.training_hours}}</td>
        <td>{{user.interview_hours}}</td>
        <td>{{user.author_hours}}</td>
        <td>{{user.total_hours}}</td>
        <td>${{user.sp_rate}}</td>
        <td>${{user.no_show_rate}}</td>
        <td>${{user.learner_tech_rate}}</td>
        <td>${{user.late_canc_rate}}</td>
        <td>${{user.early_canc_rate}}</td>
        <td>${{user.observer_rate}}</td>
        <td>${{user.trainer_rate}}</td>
        <td>${{user.training_rate}}</td>
        <td>${{user.interview_rate}}</td>
        <td>${{user.author_rate}}</td>
        <td>${{user.sp_total}}</td>
        <td>${{user.no_show_total}}</td>
        <td>${{user.learner_tech_total}}</td>
        <td>${{user.late_canc_total}}</td>
        <td>${{user.early_canc_total}}</td>
        <td>${{user.scorecard_total}}</td>
        <td>${{user.trainer_total}}</td>
        <td>${{user.training_total}}</td>
        <td>${{user.interview_total}}</td>
        <td>${{user.author_total}}</td>
        <td>${{user.total}}</td>
	</tr>
	<tr v-for="job in user.jobs" v-bind:key="job.number" :class="'user_jobs_' + user.user_id" class="collapse job-row">
        <td></td>
        <td>{{job.number}}</td>
        <td>-</td>
        <td>{{job.sp_hours}}</td>
        <td>{{job.no_show_hours}}</td>
        <td>{{job.learner_tech_hours}}</td>
        <td>{{job.late_canc_hours}}</td>
        <td>{{job.early_canc_hours}}</td>
        <td>{{job.scorecard_hours}}</td>
        <td>{{job.trainer_hours}}</td>
        <td>{{job.training_hours}}</td>
        <td>-</td>
        <td>{{job.author_hours}}</td>
        <td>{{job.total_hours}}</td>
        <td>${{user.sp_rate}}</td>
        <td>${{user.no_show_rate}}</td>
        <td>${{user.learner_tech_rate}}</td>
        <td>${{user.late_canc_rate}}</td>
        <td>${{user.early_canc_rate}}</td>
        <td>${{user.observer_rate}}</td>
        <td>${{user.trainer_rate}}</td>
        <td>${{user.training_rate}}</td>
        <td>${{user.interview_rate}}</td>
        <td>${{user.author_rate}}</td>
        <td>${{job.sp_total}}</td>
        <td>${{job.no_show_total}}</td>
        <td>${{job.learner_tech_total}}</td>
        <td>${{job.late_canc_total}}</td>
        <td>${{job.early_canc_total}}</td>
        <td>${{job.scorecard_total}}</td>
        <td>${{job.trainer_total}}</td>
        <td>${{job.training_total}}</td>
        <td>-</td>
        <td>${{job.author_total}}</td>
        <td>${{job.total}}</td>
    </tr>
</template>
<script lang="ts">
	import {defineComponent, ref} from 'vue';
	export default defineComponent({
		name: "financial-row",
		props: {
			user: {required:true,type:Object},
            ind: {required:true,type:Number},
		},
		setup(props){
            const expanded = ref<boolean>(false);
            const expand = () => {
                var collapsibles = document.getElementsByClassName('user_jobs_' + props.user.user_id);
                Array.prototype.forEach.call(collapsibles, function(collapsible){
                    collapsible.classList.toggle('collapse');
                });
                expanded.value = !expanded.value;
            }
			return {
				expanded,
                expand
			}
		}
	});
</script>